import { render, staticRenderFns } from "./Database.vue?vue&type=template&id=403bf982&scoped=true"
import script from "./Database.vue?vue&type=script&lang=ts"
export * from "./Database.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403bf982",
  null
  
)

export default component.exports